import styled from 'styled-components';
import { Colors, Text, Box } from 'basic-ui-lib';
import { IcClose } from 'basic-ui-lib/icons';

interface ContentHeaderProps {
  onClose: () => void;
}

const ContentHeader = ({ onClose }: ContentHeaderProps) => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" padding={24} position="relative">
      <Text title_h5 semibold color="neutral.text.5">
        Content
      </Text>
      <CloseButton onClick={onClose}>
        <IcClose width={24} height={24} fill={Colors.neutral.text[5]} />
      </CloseButton>
    </Box>
  );
};

export default ContentHeader;

const CloseButton = styled.button`
  position: absolute;
  top: 50%;
  right: 24px;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    background-color: ${Colors.neutral.bg[2]};
  }
`;
